import {alias, createModelSchema, raw} from "serializr";
import {BaseObject} from "@/common/BaseObject";

export class LocalizationModel extends BaseObject {

    constructor() {
        super();
        this._tabs = [{name:"en", flag:'gb'}]//, {name:"ru", flag:'ru'}, {name:"it", flag:'it'}]
        this._groups = null;
        this._keys = null;
    }

    get tabs() {
        return this._tabs;
    }

    set tabs(value) {
        this._tabs = value;
    }

    get keys() {
        return this._keys;
    }

    set keys(value) {
        this._keys = value;
    }

    get groups() {
        return this._groups;
    }

    set groups(value) {
        this._groups = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LocalizationModel());
        } else if (target instanceof LocalizationModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(LocalizationModel, {
    _groups: alias("groups", raw()),
    _keys: alias("keys", raw())
});